<div class="attribute-header">
  <div class="header-actions">
    <button mat-flat-button color="primary" (click)="openDialog()">Añadir</button>
  </div>
</div>

<div class="scrollable-table">
  <app-data-table *ngIf="attribute$ | async as attributeData" [data]="attributeData" [columns]="columns" [rows]="50"
    [rowsPerPageOptions]="[10, 25, 50]" (rowSelect)="onRowSelect($event)" [selection]="selectedItems"
    (selectionChange)="onSelectionChange($event)" [sortField]="'library'" [sortOrder]="-1" [showFilters]="true"
    (editItem)="openDialog($event)">
  </app-data-table>
</div>